import "./App.css";
import AnimatedSlider from "./components/AnimatedSlider";
import StackedSlider from "./components/StackedSlider";

function App() {
  return (
    <div >
      {/* <AnimatedSlider /> */}
      <StackedSlider />
    </div>
  );
}

export default App;
